import React, { useState } from 'react';
import { useQuery } from '@common/hooks';
import { Drawer, Tabs } from '@common/components';
import { SPEARFISHING_CAMPAIGN } from '@scheduling/graphql/queries';
import { Summary } from './_summary';
import { Recipients } from './_recipients';

export function MessageDetailDrawer({
  open,
  onClose,
  messageId = '',
  hideShiftDetail,
}: {
  open: boolean;
  onClose: () => void;
  messageId?: string;
  hideShiftDetail?: boolean;
}) {
  const [tab, setTab] = useState('summary');

  const { data, loading } = useQuery(SPEARFISHING_CAMPAIGN, {
    fetchPolicy: 'no-cache',
    skip: !messageId,
    variables: {
      id: messageId,
    },
  });

  const onDrawerClose = () => {
    setTab('summary');
    onClose();
  };

  const tabItems = [
    {
      key: 'summary',
      label: 'Summary',
      children: (
        <Summary
          spearfishingCampaign={data?.spearfishingCampaign}
          hideShiftDetail={hideShiftDetail}
        />
      ),
    },
    {
      key: 'recipients',
      label: `Recipients (${
        data?.spearfishingCampaign?.campaign?.spearfishingNotifications
          ?.length || 0
      })`,
      children: (
        <Recipients spearfishingCampaign={data?.spearfishingCampaign} />
      ),
    },
  ];

  return (
    <Drawer
      open={open}
      className="message-detail-drawer"
      title="Message Details"
      onClose={onDrawerClose}
      loading={loading}
    >
      <Tabs
        className="ShiftDetails"
        onChange={setTab}
        activeKey={tab}
        containerStyle={{
          height: 'auto',
        }}
        items={tabItems}
      />
    </Drawer>
  );
}
